import { useCallback } from "react";
import { useCommand } from "@lookiero/messaging-react";
import { clearNotifications } from "../../../../domain/notification/command/clearNotifications";
const useClearNotifications = ({ contextId, logger }) => {
    const [commandBus, status] = useCommand({ contextId });
    const clear = useCallback(async () => {
        try {
            await commandBus(clearNotifications());
            await new Promise((resolve) => setTimeout(resolve, 700));
        }
        catch (error) {
            logger.captureException(error);
        }
    }, [commandBus, logger]);
    return [clear, status];
};
export { useClearNotifications };
